/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

export function getConfig() {
  return window.__APP_CONFIG__ || {};
}
